<template>
  <div class="passenger-expand">
    <div class="passenger-expand__list"
      :class="getToggleClass"
      ref="passengers">
      <p class="value"
        v-for="person in passengers"
        :key="person.id">
          <span>{{ person.name }}</span>
        </p>
    </div>
    <a class="link link--read-more link--read-more-left"
      v-if="showExpand"
      @click="toggleExpand()">
      <lennoc-icon image="chevron-top" domClass="icon--circled"></lennoc-icon>
      <span>{{ getText }}</span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'PassengerList',
  props: {
    passengers: {
      type: Array,
      required: true
    },
    visiblePassengers: {
      type: Number,
      required: true
    },
    openText: {
      type: String,
      required: true
    },
    closedText: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      expand: false,
      height: '',
      open: false
    }
  },
  mounted () {
    if (this.showExpand) {
      const height = this.$refs.passengers.clientHeight
      this.height = height
      this.$refs.passengers.style.height = (this.height / this.passengers.length) * this.visiblePassengers + 'px'
    }
  },
  computed: {
    getText () {
      if (this.open) {
        return this.closedText
      } else {
        return this.openText
      }
    },
    getToggleClass () {
      return this.open ? 'passenger-expand__list--open' : ''
    },
    showExpand () {
      return this.visiblePassengers < this.passengers.length ? true : ''
    }
  },
  methods: {
    toggleExpand () {
      if (!this.open) {
        this.$refs.passengers.style.height = this.height + 'px'
        this.open = true
      } else {
        this.$refs.passengers.style.height = (this.height / this.passengers.length) * this.visiblePassengers + 'px'
        this.open = false
      }
    }
  }
}
</script>
